export default class MysolvrEntryListController {
  constructor(MysolvrEntry, $stateParams, handleEntryEdit) {
    'ngInject';

    this.MysolvrEntry = MysolvrEntry;
    this.$stateParams = $stateParams;
    this.handleEntryEdit = handleEntryEdit;
    this.mysolvrEntries = [];
  }

  $onInit() {
    this.searchParams = {
      filter: this.$stateParams.filter,
      page: 1,
    };

    this.loadMysolvrEntries(this.searchParams);
  }


  loadMore() {
    this.searchParams.page += 1;
    this.loadMysolvrEntries(this.searchParams);
  }

  loadMysolvrEntries(params = { filter: 'solutions' }) {
    const oldMysolvrEntries = this.mysolvrEntries;
    this.loading = true;
    this.MysolvrEntry.query(this.searchParams).$promise
      .then((response) => {
        this.lastResponse = response.mysolvr_entries;
        response.mysolvr_entries.forEach((entry) => {
          this.mysolvrEntries.push(new this.MysolvrEntry(entry));
        });
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
        this.mysolvrEntries = oldMysolvrEntries;
      });
  }

  createNewEntry() {
    const newEntry = new this.MysolvrEntry({
      type: this.filterToType(this.$stateParams.filter),
    });
    this.handleEntryEdit(newEntry)
      .then((response) => {
        this.mysolvrEntries.unshift(response);
      });
  }

  filterToType(s){
    const res = s.replace(/(\_\w)/g, function(m){return m[1].toUpperCase();});
    return res.charAt(0).toUpperCase() + res.slice(1, -1);
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/mysolvr-entries/screens/mysolvr-entry-list/mysolvr-entry-list.controller.js